// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__i8K2l","error":"Textarea_error__2Ah_G","readonly":"Textarea_readonly__2mcjD","disabled":"Textarea_disabled__3t0HK"};